import actionTypes from 'constants/actionTypes'
import { updateShape } from 'actions/shapes'
import { selectShapesByEntity, selectShapes } from 'selectors/graph/shapes'
import type { MiddlewareStoreShape, NextFn } from 'types/adapters'
import type { RootState } from 'types/state'

type ShapesAction = {
  type?: string
  payload?: {
    id?: string
    entityIds?: string[]
    layout?: boolean
  }
}

type MiddlewareStore = Pick<MiddlewareStoreShape<RootState>, 'getState' | 'dispatch'>

export default (store: MiddlewareStore) => (next: NextFn<ShapesAction>) => (action: ShapesAction) => {
  if (action.type === actionTypes.SHAPES.ADD && action.payload?.layout) {
    const state = store.getState()
    const byEntity = selectShapesByEntity(state)
    const allShapes = selectShapes(state)
    const newShapeId = action.payload.id
    const entityIds = action.payload.entityIds ?? []

    // For each entity in the new shape, disable layout on other shapes
    const disabledShapes = new Set<string>()
    for (const entityId of entityIds) {
      const shapeIds = byEntity[entityId]
      if (!shapeIds) continue
      for (const shapeId of shapeIds) {
        if (shapeId === newShapeId || disabledShapes.has(shapeId)) continue
        if (allShapes[shapeId]?.layout) {
          disabledShapes.add(shapeId)
        }
      }
    }

    // Dispatch layout: false for conflicting shapes before the ADD goes through
    for (const shapeId of disabledShapes) {
      store.dispatch(updateShape(shapeId, { layout: false }) as unknown as ShapesAction)
    }
  }

  return next(action)
}
